// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"iD7xP","popoverWrapper":"iD7xP","root":"_1crTJ"};